<template>
  <el-container>
    <router-view v-if="isRouterAlive" v-slot="{ Component, route }">
      <template v-if="Component">
        <!-- 仅 knowledge 走 App 级 keep-alive；勿用 route.meta.keepAlive（子路由 meta 会合并，曾导致角色页整页重建） -->
        <keep-alive v-if="route.name === 'knowledge'">
          <component :is="Component" :key="topLevelRouteKey(route)" />
        </keep-alive>
        <component v-else :is="Component" :key="topLevelRouteKey(route)" />
      </template>
    </router-view>
    <loading />
  </el-container>
</template>

<script setup lang="ts">
import { provide, ref, nextTick, inject, onMounted } from 'vue';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import Loading from '@/components/Loading.vue';

const mergeCheckpointIntoAppConfig = inject<(() => Promise<void>) | undefined>(
  'mergeCheckpointIntoAppConfig',
  undefined
);
onMounted(() => {
  mergeCheckpointIntoAppConfig?.();
});

function topLevelRouteKey(route: RouteLocationNormalizedLoaded) {
  // 必须固定为同一字符串：若回退到 route.path，/home 下子路由切换会改 key，整页重建 Home（像刷新）
  if (route.matched.some((r) => r.name === 'home')) {
    return 'home';
  }
  const top = route.matched[0];
  return (top?.name as string | undefined) ?? top?.path ?? route.path;
}

const isRouterAlive = ref(true);
const reload = () => {
  isRouterAlive.value = false;
  nextTick(() => {
    isRouterAlive.value = true;
  });
};

provide('reload', reload);
</script>

<style scoped></style>
<style>
/* WebView / 高 DPI 缩放下与宿主窗口等高，避免整页出现滚动条 */
.el-container {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
</style>
